module.exports = {
    // 测评医生端测试环境
    VERSION_ROOT: 'https://software.medkg.cn/', // 版本请求地址
    // GLOBAL_API_ROOT: 'http://127.0.0.1:8001/', // 后端请求地址
    GLOBAL_API_ROOT: 'https://ceping.xytcmai.com/', // 后端请求地址ceping-hnsz.xytcmai.com
    // GLOBAL_API_ROOT: 'https://jvpegjcvoors.sealosgzg.site/', // 浩天
    SETTING: { // 项目特殊配置
        ifDesktop: false, // 是否是桌面端
        ifVerifyLight: false,
        ziWaiLight: false,
        ifPushToSaaS: false, // 是否推送数据到 SaaS 系统
        ifAutoUpdate: false, //是否自动更新
        ifVerify: false,
        ifShowLogo: true,
        ifShowLoginBg: true,
        mode: 'bianzheng', // sizhen是四诊和测评，tizhi是只有测评，bianzheng是望诊问诊
    },
    ID: "", // 用来获取项目信息，如果不需要通过请求获取，则此字段不要填，填下面SYSTEM_MSG字段
    SYSTEM_MSG: {
        name: '中医诊测采集分析系统大模型 ', // 项目名称
        logo: '/common/hnsz.png',
        favicon_url: '/common/hnsz.ico'
    },
    THEME: {
        defaultSize: '大', // 默认字号
        ifCanChangeSize: false, // 是否允许在头部切换字号
        // 文字大小配置,
        bigSize: '30px', //大版30，小版28
        h1Size: '22px', //大版22，小版20
        h2Size: '20px', //大版20，小版18
        h3Size: '18px', //大版18，小版16
        mainSize: '16px', //大版16，小版14
        miniSize: '14px', //大版14，小版12
        templateSize: '20px', // 模板内容字体大小

        primaryColor: '#3DA6E8', // 主题色
        subPrimaryColor: '#1B5AB2', // 副主题色
        miniPrimaryColor: 'rgba(110, 64, 0, 0.1)', // 浅主题色
        tableBorderColor: 'rgba(110, 64, 0, 0.1)', // 表格头部底色
        tableHoverColor: 'rgba(82,180,231, 0.4)', // 表格鼠标底色
        scrollbarColor: 'rgba(61,166,232, 0.4)', //滚动条颜色
        pageBg: "url('/common/page-bg2.png')", //页面背景底图

        // 白色底的四周阴影配置
        boxShadow: '0 2 px 12 px 0 rgba(0, 0, 0, 0.15)', // 四周阴影
    },
    SYSTEM_NAV: {},

    // 以下是打包桌面端需要用到的
    // electron-builder.yml
    APP_ID: 'com.hnsz.www', // 应用的唯一id,确认后不要改动了！不然在更新时候，会被认做为两个应用。这个是在apple那里你申请证书的时候，用生成的那个id就可以，类似这种'com.example.app'
    COPYRIGHT: 'hnsz', // 版权信息
    // 以下图标从请求获取
    LOGO: './public/common/hnsz.ico', // logo路径,格式为.ico，大小需要256*256的，否则打包会报错

    // package.json
    VERSION: '0.0.1', //版本号
    PACKAGE_NAME: 'hnsz', //包名
}